module.exports = __webpack_public_path__ + "img/BBB_logo2.19bdb295.png";